type PropType = {
  count: number
  show?: boolean
}
const OrderHistory = ({ count, show = true }: PropType) => {
  if (!show) {
    // return null
  }
  return (
    <div className="flex bg-gradient-to-r from-[#B9F987]/[.15] to-[#80F06E]/[.15] w-[184px] h-[37px] justify-center items-center mx-auto py-2.5 px-5 mb-8">
      <p className="text-base font-medium leading-9 text-[#107715]">
        {`سابقه خرید: ${count} بار`}
      </p>
    </div>
  )
}

export default OrderHistory
